import NotificationPanel from "../../notification";

export default function Notification() {
    
  return (
     <div className=" px-3 sm:px-8">
     <NotificationPanel  userType='user'/>
    </div>
  );
}